<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="12" sm24 v-for="(video, index) in videos" :key="index">
        <card>
          <card-text>
            <vid @ready="onReady(video)" :src="video.src" :width="video.width" :height="video.height" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageVid',
  mixins: [
    methods
  ],
  data () {
    return {
      videos: []
    }
  },
  mounted () {
    this.getExternalData('vid.json', 'videos')
  },
  methods: {
    onReady ($event) {
      this.log('ready', 'vid', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/vid.vue